<template>
  <div class="countriesContainer" :class="expanded ? 'expanded' : 'collapsed'">
    <div>
      <span class="application-heading">Countries:</span>
      <span v-if="countries && countries.length > 5" class="seeAllHolder">
        <a @click="expanded = !expanded">
          <span v-if="!expanded">SEE ALL</span>
          <span v-if="expanded">SEE LESS</span>
        </a>
      </span>
    </div>
    <div class="countriesList">
      <span
        class="countryListing"
        v-for="(country, countryIndex) in countries"
        :key="countryIndex"
      >
        <DetailsListItemCountryChip
          class="countryCol"
          :key="country.code"
          :name="country.name"
          :code="country.code.toUpperCase()"
          :flagUrl="country.flagUrl"
          :theme="theme"
        ></DetailsListItemCountryChip>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "DetailsListItemCountries",
  props: {
    countries: {
      type: Array,
      default: () => [],
    },
    theme: {
      type: String,
    },
  },
  components: {
    DetailsListItemCountryChip: () =>
      import("@/components/common/details/DetailsListItemCountryChip"),
  },
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    countriesGrouped() {
      let res = [];
      const chunkSize = 5;
      for (let i = 0; i < this.countries.length; i += chunkSize) {
        const chunk = this.countries.slice(i, i + chunkSize);
        res.push(chunk);
      }
      return res;
    },
  },
};
</script>

<style scoped>
.countriesContainer {
  width: 100%;
}
.countriesContainer.collapsed {
  height: 2.5lh;
  overflow: hidden;
}

.countryCol {
  margin-right: 2px;
}

.seeAllHolder {
  float: right;
}

.countriesList {
  width: 100%;
  display: inline-grid;
  grid-template-columns: repeat(auto-fit, 63px);
}

.countryListing {
  padding-right: 2px;
}
</style>
